module.exports = __webpack_public_path__ + "img/atadas.c472c9e3.jpg";